import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { get_indices3txodfl5wuu5j as get_indices } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ListClass;
function List() {
  if (ListClass === VOID) {
    class $ extends State() {
      constructor(list) {
        super();
        this.i4c_1 = list;
      }
      toString() {
        return 'List (' + this.i4c_1.v2() + ')';
      }
    }
    initMetadataForClass($, 'List');
    ListClass = $;
  }
  return ListClass;
}
var MapClass;
function Map() {
  if (MapClass === VOID) {
    class $ extends State() {
      constructor(map, name) {
        super();
        this.j4c_1 = map;
        this.k4c_1 = name;
      }
      toString() {
        return 'Map (' + this.k4c_1 + ')';
      }
    }
    initMetadataForClass($, 'Map');
    MapClass = $;
  }
  return MapClass;
}
var StateClass;
function State() {
  if (StateClass === VOID) {
    class $ {}
    initMetadataForClass($, 'State');
    StateClass = $;
  }
  return StateClass;
}
function mergeWith($this, _this__u8e3s4, other) {
  if (_this__u8e3s4 == null) {
    return other;
  }
  if (other == null) {
    return _this__u8e3s4;
  }
  var tmp;
  if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList()) : false) {
    // Inline function 'kotlin.check' call
    if (!(!(other == null) ? isInterface(other, KtList()) : false)) {
      var message = 'Cannot merge ' + toString(_this__u8e3s4) + ' with ' + toString_0(other);
      throw IllegalStateException().o(toString(message));
    }
    // Inline function 'kotlin.check' call
    if (!(_this__u8e3s4.v2() === other.v2())) {
      var message_0 = 'Cannot merge ' + toString(_this__u8e3s4) + ' with ' + toString(other);
      throw IllegalStateException().o(toString(message_0));
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_indices(_this__u8e3s4);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().m2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.v3_1;
    var last = this_0.w3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var i = item;
        var tmp$ret$4 = mergeWith($this, _this__u8e3s4.w2(i), other.w2(i));
        destination.n2(tmp$ret$4);
      }
       while (!(item === last));
    tmp = destination;
  } else {
    if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) {
      // Inline function 'kotlin.check' call
      if (!(!(other == null) ? isInterface(other, KtMap()) : false)) {
        var message_1 = 'Cannot merge ' + toString(_this__u8e3s4) + ' with ' + toString_0(other);
        throw IllegalStateException().o(toString(message_1));
      }
      if (!isInterface(_this__u8e3s4, KtMap()))
        THROW_CCE();
      if (!isInterface(other, KtMap()))
        THROW_CCE();
      // Inline function 'kotlin.collections.map' call
      var this_1 = plus(_this__u8e3s4.a5(), other.a5());
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().m2(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s = this_1.u1();
      while (_iterator__ex2g4s.v1()) {
        var item_0 = _iterator__ex2g4s.w1();
        var tmp$ret$9 = to(item_0, mergeWith($this, _this__u8e3s4.z4(item_0), other.z4(item_0)));
        destination_0.n2(tmp$ret$9);
      }
      tmp = toMap(destination_0);
    } else {
      // Inline function 'kotlin.check' call
      if (!equals(_this__u8e3s4, other)) {
        var message_2 = 'Cannot merge ' + toString_0(_this__u8e3s4) + ' with ' + toString_0(other);
        throw IllegalStateException().o(toString(message_2));
      }
      tmp = _this__u8e3s4;
    }
  }
  return tmp;
}
function valueInternal($this, value) {
  // Inline function 'kotlin.apply' call
  var state = lastOrNull($this.k40_1);
  if (state instanceof Map()) {
    var name = state.k4c_1;
    // Inline function 'kotlin.check' call
    if (!!(name == null)) {
      throw IllegalStateException().o('Check failed.');
    }
    if (state.j4c_1.x4(name)) {
      var tmp0 = state.j4c_1;
      // Inline function 'kotlin.collections.set' call
      var value_0 = mergeWith($this, state.j4c_1.z4(name), value);
      tmp0.c5(name, value_0);
    } else {
      // Inline function 'kotlin.collections.set' call
      state.j4c_1.c5(name, value);
    }
    state.k4c_1 = null;
  } else {
    if (state instanceof List()) {
      state.i4c_1.n2(value);
    } else {
      $this.i40_1 = value;
      $this.j40_1 = true;
    }
  }
  return $this;
}
var MapJsonWriterClass;
function MapJsonWriter() {
  if (MapJsonWriterClass === VOID) {
    class $ {
      constructor() {
        this.i40_1 = null;
        this.j40_1 = false;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.k40_1 = ArrayList().u2();
      }
      s40() {
        // Inline function 'kotlin.check' call
        if (!this.j40_1) {
          throw IllegalStateException().o('Check failed.');
        }
        return this.i40_1;
      }
      u40() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableListOf' call
        var list = ArrayList().u2();
        this.k40_1.n2(new (List())(list));
        return this;
      }
      v40() {
        // Inline function 'kotlin.apply' call
        var state = this.k40_1.h5(this.k40_1.v2() - 1 | 0);
        // Inline function 'kotlin.check' call
        if (!(state instanceof List())) {
          throw IllegalStateException().o('Check failed.');
        }
        valueInternal(this, state.i4c_1);
        return this;
      }
      p40() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableMapOf' call
        var map = LinkedHashMap().gc();
        this.k40_1.n2(new (Map())(map, null));
        return this;
      }
      q40() {
        // Inline function 'kotlin.apply' call
        var state = this.k40_1.h5(this.k40_1.v2() - 1 | 0);
        // Inline function 'kotlin.check' call
        if (!(state instanceof Map())) {
          throw IllegalStateException().o('Check failed.');
        }
        valueInternal(this, state.j4c_1);
        return this;
      }
      r47(name) {
        // Inline function 'kotlin.apply' call
        var state = last(this.k40_1);
        // Inline function 'kotlin.check' call
        if (!(state instanceof Map())) {
          throw IllegalStateException().o('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(state.k4c_1 == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        state.k4c_1 = name;
        return this;
      }
      w49() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.k40_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().m2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var tmp;
          if (item instanceof List()) {
            tmp = item.i4c_1.v2().toString();
          } else {
            if (item instanceof Map()) {
              var tmp1_elvis_lhs = item.k4c_1;
              tmp = tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
            } else {
              noWhenBranchMatchedException();
            }
          }
          var tmp$ret$0 = tmp;
          destination.n2(tmp$ret$0);
        }
        return joinToString(destination, '.');
      }
      b41(value) {
        return valueInternal(this, value);
      }
      l41(value) {
        return valueInternal(this, value);
      }
      g41(value) {
        return valueInternal(this, value);
      }
      d41(value) {
        return valueInternal(this, value);
      }
      j41(value) {
        return valueInternal(this, value);
      }
      h4a(value) {
        return valueInternal(this, value);
      }
      q41(value) {
        return valueInternal(this, null);
      }
      l40(value) {
        return valueInternal(this, value);
      }
      u3z() {
        return valueInternal(this, null);
      }
      q6() {
      }
    }
    initMetadataForClass($, 'MapJsonWriter', MapJsonWriter);
    MapJsonWriterClass = $;
  }
  return MapJsonWriterClass;
}
//region block: exports
export {
  MapJsonWriter as MapJsonWriter4jz7ym6vbwk4,
};
//endregion

//# sourceMappingURL=MapJsonWriter.mjs.map
